export const headersWithoutCredentials = { 'Content-Type': 'application/json' }

export const HeadersWithCredentials = (token = localStorage.getItem('token')) => ({
    ...headersWithoutCredentials,
    Authorization: 'Bearer ' + token,
})
